import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, ValidationOptions, registerDecorator } from 'class-validator';

@ValidatorConstraint()
export class TenantDetailsIsMpnIdServerValidatedConstraint implements ValidatorConstraintInterface {

  validate(value: string, validationArguments: ValidationArguments) {
    const isMpnValid: boolean = (validationArguments.object as any)[validationArguments.constraints[0]];
    const isMpnValidated: boolean = (validationArguments.object as any)[validationArguments.constraints[1]];

    // If not validated skip this constraint
    if (!isMpnValidated) {
      return true;
    }

    return isMpnValid;
  }
}

export function TenantDetailsIsMpnIdServerValidated(isMpnValid: string, isMpnValidated: string, validationOptions?: ValidationOptions) {
  return (object: any, propertyName: string) => {
    registerDecorator({
      target: object.constructor,
      propertyName,
      options: validationOptions,
      constraints: [isMpnValid, isMpnValidated],
      validator: TenantDetailsIsMpnIdServerValidatedConstraint,
    });
  };
}
